import Vue from 'vue';
import VeeValidate from 'vee-validate';
import nl from 'vee-validate/dist/locale/nl';
import axios from 'axios';
import VueRecaptcha from 'vue-recaptcha';

Vue.use(VeeValidate);

Vue.component('contactform', {
    components: {
        'vue-recaptcha': VueRecaptcha
    },
    data: function() {
        return {
            form: {
                salutation: 'Dhr. / Mr.',
                name: '',
                organisation: '',
                email: '',
                phone: '',
                question: ''
            },
            active: false,
            submitted: false
        };
    },
    mounted() {
        this.$validator.localize('nl', nl);
    },
    methods: {
        formSubmit(e) {
            e.preventDefault;
            this.$validator.validateAll().then(result => {
                if (result) {
                    this.active = true;
                    this.$refs.recaptcha.execute();
                }
            });
        },
        postForm(recaptchaToken) {
            this.$refs.recaptcha.reset();
            const formData = new FormData();
            formData.append('salutation', this.form.salutation);
            formData.append('organisation', this.form.organisation);
            formData.append('name', this.form.name);
            formData.append('email', this.form.email);
            formData.append('phone', this.form.phone);
            formData.append('question', this.form.question);
            formData.append('token', recaptchaToken);

            axios
                .post('/ajax/ajax/ContactForm', formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                })
                .then(response => {
                    if (response.data.Status == 'success') {
                        this.submitted = true;
                    } else {
                        this.submitted = false;
                    }
                    this.active = false;
                })
                .catch(function() {
                    this.active = false;
                    this.submitted = false;
                });
        }
    }
});
